/**
 * Return error message string
 *
 * @param name - the name to validate
 * @returns string providing any details if name is not valid
 */
export function getServiceAccountNameErrorMessage(name: string): string {
  let errorMessage = null;
  // do not return a validation status until the user has entered a value
  if (name !== null) {
    if (name === ``) {
      errorMessage = `Name cannot be empty`;
    } else if (!/^[\w_-]+$/.test(name)) {
      errorMessage = `Name can only contain letters, numbers, dashes, and underscores`;
    }
  }
  return errorMessage;
}
